import { sendPost } from "../helpers";

const postRecommend = async (params, onSucces = () => {}, onError = () => {}) => {
    
    try {
      const res = await sendPost("/chart-data/recommend-product", params);
      if (res.status === 200) {
        onSucces(res?.data);
      }
    } catch (error) {
    }
}
    const  listRecommend = {postRecommend};
    export default listRecommend;